"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.stringify = void 0;
/**
 * 默认进行相关stringify和parse转换
 */
exports.stringify = function (val) {
    try {
        val = JSON.stringify(val);
    }
    catch (e) {
        val = String(val);
    }
    return val;
};
exports.parse = function (val) {
    try {
        val = val ? JSON.parse(val) : val;
    }
    catch (e) { }
    return val;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/shared-utils/dist/storage/index.js
// module id = yVQZ
// module chunks = 1